import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import Input from '@/components/@base/input/text';
import { INPUT_TYPES } from '@/components/@base/input/text/type';
import cn from '@/lib/clsxm';
import { useState } from 'react';
import { convertToEnglishNumber, currency } from '@/lib/helper';
import Button from '@/components/@base/button';
import { SIZE_ENUM } from '@/components/@base/@types';
import useCommonModalStore from '@/store/common-modal-store';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import { usePostCheckWalletInquiry } from '@/services/hooks';
// import useHomeStore from '@/store/home';
import kipaLogo from '@/assets/mock-items/kipa-logo.svg'
import kipa from '@/assets/mock-items/kipa.svg';
const MAX_INPUT_LENGTH = 30;
const PaymentWithIdModal = () => {
  const { setShow } = useCommonModalStore();
  // const { invoice  } = useHomeStore();
  const { mutate, isPending } = usePostCheckWalletInquiry()
  const {
    setRefetchSegments
  } = useUserWalletsVouchersStore();
  const [paymentId, setPaymentId] = useState<string | null>(null);
  const [providerWallet, setProviderWallet] = useState<number | null>(null);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;

    const numericValue = convertToEnglishNumber(rawValue);
    if (rawValue.length > MAX_INPUT_LENGTH) return;
    if (isNaN(+numericValue)) return;
    if (+numericValue < 0) return;
    setPaymentId(numericValue);
  };
  const closeModal = () => {
    setShow(false);
    setPaymentId(null);
  }
  const submitPaymentId = () => {
    paymentId && mutate({
      WalletProviderCustomerId: paymentId.toString(),
    }, {
      onSuccess: (res)=> {
        setProviderWallet(res?.data?.balance);
        setRefetchSegments(true);
      }
    })
  }
  const addWalletId = () => {
    setShow(false);
    setPaymentId(null);
    setProviderWallet(null);
  }
  return (
    <Container className='p-4 pt-6'>
      {providerWallet && (
        <Container
          center
          className='w-full flex-col rounded-xl bg-grayLight-50 py-6 dark:bg-grayDark-700'
        >
          <img src={kipaLogo} alt='kipa logo' />
          <Text className='mt-3 text-black dark:text-white' medium>
            کیف‌پول کیپا
          </Text>
          <Text className='text-grayLight-650 dark:text-grayLight-500' medium>
            {localization.walletProviderAmount(currency(providerWallet))}
          </Text>
        </Container>
      )}
      {!providerWallet &&
        <Container center className="flex-col w-full">
          <img src={kipa} width={40} height={40} alt="kipa"/>
          <Text
            className='mt-4 w-full text-center text-xl leading-8 text-black dark:text-white'
            semiBold
          >
            {localization.PayWithId}
          </Text>
          <Text className='text-md my-2 w-full text-center leading-7 text-grayLight-850 dark:text-grayLight-300'>
            {localization.ifYouHavePaymentId}
          </Text>
          <Input
            labelClassName='text-md'
            type={INPUT_TYPES.TEL}
            // error={true}
            // errorMessage={''}
            inputMode='text'
            className={cn(
              'text-md mb-1 mt-6 h-[52px] w-full border-grayLight-100 bg-grayLight-40 text-right text-grayLight-1000 focus:border-2 focus:border-black dark:border-grayDark-700 dark:bg-grayDark-900 dark:text-grayLight-0 focus:dark:border-white',
              // isError && "mb-10"
            )}
            placeholder={localization.enterPaymentIdPlaceholder}
            onChange={(e) => handleChange(e)}
            value={paymentId !== null ? paymentId : ''}
          />
        </Container>
      }
      <Container center className='mt-4 gap-3'>
        <Button
          className='text-md w-[116px] whitespace-nowrap rounded-full bg-red-50 px-8 text-danger-450 hover:bg-danger-450/20 dark:bg-red-900 dark:text-red-300'
          style={{ height: '52px' }}
          size={SIZE_ENUM.XL}
          // onClick={handleRedirect}
          onClick={closeModal}
        >
          {localization.refuse}
        </Button>
        <Button
          className='text-md w-full cursor-pointer whitespace-nowrap rounded-full px-8'
          style={{ height: '52px' }}
          size={SIZE_ENUM.XL}
          disabled={!paymentId || isPending}
          isLoading={isPending}
          onClick={providerWallet ? addWalletId : submitPaymentId}
        >
          {providerWallet ? localization.addTheWallet : localization.confirmTheId}
        </Button>
      </Container>
    </Container>
  );
}
export default PaymentWithIdModal;